import { render, staticRenderFns } from "./DynamicFormCard.vue?vue&type=template&id=3896859f&"
import script from "./DynamicFormCard.vue?vue&type=script&lang=js&"
export * from "./DynamicFormCard.vue?vue&type=script&lang=js&"
import style0 from "./DynamicFormCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports